module.exports = __webpack_public_path__ + "img/logo_gobierno_del_encontro.4a430a21.png";